import React, { useState } from "react";
import {
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  translate,
} from "react-admin";
import {
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@material-ui/core";

import { API_URL } from "../config";
import BackButton from "../components/buttons/BackButton";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import ProcedureIcon from "@material-ui/icons/Autorenew";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { createUseStyles } from "react-jss";
import theme from "../theme";
import { withStyles } from "@material-ui/core/styles";

const CustomToolbar = withStyles((theme) => ({
  toolbar: {
    "& button": {
      marginRight: theme.spacing.unit * 2,
    },
  },
}))(({ classes, ...props }) => {
  return (
    <Toolbar {...props} classes={classes}>
      <SaveButton
        label="resources.procedure.buttons.run"
        icon={<PlayArrowIcon />}
        alwaysEnable
      />
      <BackButton href="#/procedure" />
    </Toolbar>
  );
});

const useStyles = createUseStyles({
  customMessage: {
    whiteSpace: "nowrap",
    "@media (max-width: 600px)": {
      whiteSpace: "normal",
    },
  },
});

const Form = (props, classes) => {
  const { record = {}, notify, translate } = props;
  const showCustomMessage = record.name === "BonificaDeviceTest";
  const parameters = record.parameters || [];

  const [tabIndex, setTabIndex] = useState(0);
  const [logData, setLogData] = useState([]);
  const locale = localStorage.getItem("locale");

  const classesCustom = useStyles();
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleSubmit = async (values) => {
    const token = localStorage.getItem("token");
    const paramValues = parameters.map((p) => values[p.name]);

    try {
      const response = await fetch(
        `${API_URL}/procedure/${encodeURIComponent(record.name)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, params: paramValues }),
        }
      );

      const result = await response.json();

      if (!response.ok || result.success === false) {
        throw new Error(
          result.message || "Errore nella chiamata alla procedura"
        );
      }

      setLogData(result.data || []);
      setTabIndex(1);
      notify("Procedura eseguita con successo", "info");
    } catch (error) {
      notify(`${error.message}`, "warning");
    }
  };

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        style={{
          backgroundColor: "white",
          padding: 0,
        }}
      >
        <Tab
          label={translate("resources.procedure.tabs.execution")}
          icon={<ProcedureIcon />}
        />
        <Tab label="Log" icon={<VisibilityIcon />} />
      </Tabs>

      <SimpleForm
        {...props}
        initialValues={record}
        toolbar={tabIndex === 0 ? <CustomToolbar /> : null}
        save={handleSubmit}
        style={{
          backgroundColor: "white",
          padding: 0,
        }}
      >
        {tabIndex === 0 && (
          <div>
            <TextInput
              source="name"
              label="resources.procedure.label.name"
              disabled
              fullWidth
            />
            {parameters.map((param) => (
              <TextInput
                key={param.name}
                source={param.name}
                label={
                  (param.label?.[locale] || param.label?.it || param.name) + "*"
                }
              />
            ))}
          </div>
        )}

        {showCustomMessage && tabIndex === 0 && (
          <Typography
            variant="body1"
            className={classesCustom.customMessage}
            style={{
              margin: "16px 0",
              fontSize: "13px",
              color: theme.palette.text.secondary,
            }}
          >
            {translate("resources.procedure.message.info")}
          </Typography>
        )}

        {tabIndex === 1 && (
          <div style={{ marginTop: "16px", width: "100%" }}>
            {logData.length > 0 ? (
              <div style={{ width: "100%", overflowX: "auto" }}>
                <Table size="small" style={{ width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: "80px", fontWeight: "bold" }}>
                        {translate("resources.procedure.logs.number")}
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        {translate("resources.procedure.logs.message")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {logData.map((line, index) => {
                      const containsTransazione = line.includes("Transazione");
                      return (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell
                            style={{
                              whiteSpace: "pre-wrap",
                              color: containsTransazione ? "green" : "inherit",
                              fontWeight: containsTransazione
                                ? "bold"
                                : "normal",
                            }}
                          >
                            {line}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <Typography variant="body2" color="textSecondary">
                {translate("resources.procedure.logs.empty")}
              </Typography>
            )}
          </div>
        )}
      </SimpleForm>
    </>
  );
};

export default translate(Form);
